module.exports = __webpack_public_path__ + "img/uz_img2.315c511b.png";